import { PageViewAnalytics } from '~/components/PageViewAnalytics'
import GridList from '~/components/UI/GridList'
import GridListNav from '~/components/UI/GridListNav'
import HeroGridList from '~/components/UI/HeroGridList'

import { getBlogListStaticPropsFunction } from '~/data/blog-list-page-data'
import { BlogListPageData } from '~/data/blog-list-page-data/serializer'

import css from './styles.module.scss'

function BlogListPage({ hero, grid }: BlogListPageData) {
  return (
    <>
      <section className={css.BlogListPage}>
        <div className={css.content}>
          {hero && <HeroGridList {...hero} />}
          {grid && <GridList hasReadMore hasPagination {...grid} />}
        </div>
        {hero?.links && (
          <GridListNav className={css.stickyNav} links={hero?.links} />
        )}
      </section>
      <PageViewAnalytics template="blog" />
    </>
  )
}

export default BlogListPage

export const getStaticProps = getBlogListStaticPropsFunction()
